export enum PlayerState {
  Init = 'init',
  Loading = 'loading',
  Playing = 'playing',
  Paused = 'paused',
  Stopped = 'stopped',
  Speed = 'speed',
}

export enum PlayerError {
  AudioLoadError = 'audioLoadError',
  AudioNoSound = 'audioNoSound',
}
